export const INITIALIZE_SESSION = 'INITIALIZE_SESSION';
export const STORE_DATA = 'STORE_DATA';
export const SET_PACKAGES_ORIGINAL = 'SET_PACKAGES_ORIGINAL';
export const SET_PACKAGES_FILTRADOS = 'SET_PACKAGES_FILTRADOS';
export const SET_PACKAGE_DETAILS = 'SET_PACKAGE_DETAILS';
export const SET_PACKAGES_DESTINATION_AND_ORIGIN = 'SET_PACKAGES_DESTINATION_AND_ORIGIN';
export const SET_OFFERS_ORIGINAL = 'SET_OFFERS_ORIGINAL';
export const SET_OFFERS_FILTRADOS = 'SET_OFFERS_FILTRADOS';
export const SET_GEO_DATA = 'SET_GEO_DATA';

// application state
export const SET_APP_INITIAL_DATA = 'SET_APP_INITIAL_DATA';
export const SET_TEMPLATE_DATA = 'SET_TEMPLATE_DATA';
export const GET_APPLICATION = 'GET_APPLICATION';
export const GET_NAVIGATION = 'GET_NAVIGATION';
export const GET_NAVBAR = 'GET_NAVBAR';
export const GET_FOOTER = 'GET_FOOTER';
export const GET_HEADER = 'GET_HEADER';
export const ADD_CITY = 'ADD_CITY';

// banners state
export const SET_BANNERS = 'SET_BANNERS';
export const SET_BANNERS_ERROR = 'SET_BANNERS_ERROR';
export const RESET_BANNERS_ERROR = 'RESET_BANNERS_ERROR';

// sections
export const SET_SECTION = 'SET_SECTION';
export const SET_SECTION_ERROR = 'SET_SECTION_ERROR';

// Claims form
export const SET_CLAIM_FORM_DATA = 'SET_CLAIM_FORM_DATA';
export const SET_CLAIM_FORM_STATUS = 'SET_CLAIM_FORM_STATUS';
export const RESET_CLAIM_FORM = 'RESET_CLAIM_FORM';
export const SUBMIT_CLAIM_FORM = 'SUBMIT_CLAIM_FORM';
export const SUBMIT_CLAIM_FORM_SUCCESS = 'SUBMIT_CLAIM_FORM_SUCCESS';
export const SUBMIT_CLAIM_FORM_ERROR = 'SUBMIT_CLAIM_FORM_ERROR';

// Consultation form
export const SET_CONSULTATION_FORM_DATA = 'SET_CONSULTATION_FORM_DATA';
export const SET_CONSULTATION_FORM_STATUS = 'SET_CONSULTATION_FORM_STATUS';
export const RESET_CONSULTATION_FORM = 'RESET_CONSULTATION_FORM';
export const SUBMIT_CONSULTATION_FORM = 'SUBMIT_CONSULTATION_FORM';
export const SUBMIT_CONSULTATION_FORM_SUCCESS = 'SUBMIT_CONSULTATION_FORM_SUCCESS';
export const SUBMIT_CONSULTATION_FORM_ERROR = 'SUBMIT_CONSULTATION_FORM_ERROR';

// Regret form
export const SET_REGRET_FORM_DATA = 'SET_REGRET_FORM_DATA';
export const SET_REGRET_FORM_STATUS = 'SET_REGRET_FORM_STATUS';
export const RESET_REGRET_FORM = 'RESET_REGRET_FORM';
export const SUBMIT_REGRET_FORM = 'SUBMIT_REGRET_FORM';
export const SUBMIT_REGRET_FORM_SUCCESS = 'SUBMIT_REGRET_FORM_SUCCESS';
export const SUBMIT_REGRET_FORM_ERROR = 'SUBMIT_REGRET_FORM_ERROR';
